export default [
  {
    path: '/saneamento-razao',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Saneamento do Razão Histórico',
        path: 'historico',
        component: () => import('@/views/saneamentoRazao/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Dados', path: '/dados' }, { name: 'Saneamento do Razão' }]
        }
      },
      {
        name: 'Painel Gerencial Saneamento Razão',
        path: 'painel-gerencial/:id',
        component: () => import('@/views/saneamentoRazao/PainelGerencial.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Dados', path: '/dados' },
            { name: 'Saneamento do Razão', path: '/saneamento-razao/historico' },
            { name: 'Painel Gerencial' }
          ]
        }
      }
    ]
  }
];
